var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es461.js.map
